import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { CustomButton } from "../../../../components/CustomButton";
import { showCustomToast } from "../../../../components/CustomToast";
import { ToggleSwitchBillingPaymentScheduleType } from "../../../../components/ToggleSwitchBillingPaymentScheduleType";
import {
  putCollectionPointThunk,
  updateBillingPaymentScheduleType,
  updateCollectionPointBillingPaymentDate,
} from "../../../../reducers/collectionPointReducer";
import {
  getCollectionPointIsUpdating,
  getCollectionPointPaymentSchedule,
  getCollectionPointPaymentScheduleType,
} from "../../../../selectors/collectionPoint";
import { useAppDispatch } from "../../../../store";
import { UpdateBillingPaymentScheduleDate } from "../../../../types/billing";
import { BillingPaymentScheduleType } from "../../../../types/billings";
import { BillingPaymentSchedulePicker } from "../../../BillingPage/BillingPaymentSchedule/BillingPaymentSchedulePicker";

import styles from "./BillingPaymentSchedule.module.scss";

export const BillingPaymentSchedule = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const paymentSchedule = useSelector(getCollectionPointPaymentSchedule);
  const paymentScheduleType = useSelector(getCollectionPointPaymentScheduleType);
  const isUpdating = useSelector(getCollectionPointIsUpdating);

  const onBillingPaymentScheduleTypeChange = (value: string) => {
    dispatch(updateBillingPaymentScheduleType(value as BillingPaymentScheduleType));
  };

  const onBillingPaymentDateChange = (payload: UpdateBillingPaymentScheduleDate) => {
    dispatch(updateCollectionPointBillingPaymentDate(payload));
  };

  if (!paymentSchedule || !paymentScheduleType) {
    return null;
  }

  const savePaymentSchedule = async () => {
    const result = await dispatch(putCollectionPointThunk());
    if (putCollectionPointThunk.fulfilled.match(result)) {
      showCustomToast(t("collectionPoint.billingPaymentChangeModal.successToast"), { type: "success" });
    } else if (putCollectionPointThunk.rejected.match(result)) {
      showCustomToast(t("collectionPoint.billingPaymentChangeModal.errorToast"), { type: "error" });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>{t("collectionPoint.billingPaymentSchedule.title")}</h3>
        <ToggleSwitchBillingPaymentScheduleType
          selectedValue={paymentScheduleType}
          onChange={onBillingPaymentScheduleTypeChange}
        />
      </div>
      <BillingPaymentSchedulePicker
        paymentSchedule={paymentSchedule}
        paymentScheduleType={paymentScheduleType}
        onPaymentDateChange={onBillingPaymentDateChange}
      />
      <CustomButton
        text={t("collectionPoint.billingPaymentSchedule.save")}
        className={styles.saveButton}
        onClick={savePaymentSchedule}
        disabled={isUpdating}
      />
    </div>
  );
};
